import React from "react";

const faqItems = [
  {
    question:
      "What does the PCL in General Medicine (HA) program at HVTC focus on?",
    answer:
      " It focuses on training students in medical science fundamentals and healthcare practices to become Health Assistants.",
  },
  {
    question:
      "What practical experience is included in the PCL in General Medicine (HA) program?",
    answer:
      "The program includes clinical rotations and internships in hospitals and healthcare centers.",
  },
  {
    question:
      "What career paths can graduates of the PCL in General Medicine (HA) pursue?",
    answer:
      "Graduates can work as Health Assistants in hospitals, clinics, community health centers, and NGOs, or further their education in medical sciences.",
  },
  {
    question:
      "What is the main goal of the Diploma in Pharmacy program at HVTC?",
    answer:
      "The goal is to train students in pharmaceutical sciences, medication dispensing, and patient care.",
  },
  {
    question:
      "What practical training is included in the Diploma in Pharmacy program?",
    answer:
      "The program includes laboratory work, internships in hospitals and pharmacies, and hands-on drug formulation and patient counseling experience.",
  },
];

export default function Faq() {
  return (
    <div
      data-aos="fade-up"
      data-aos-easing="linear"
      data-aos-duration="1500"
      className="flex  md:px-0 px-4 justify-center items-center"
    >
      <div className="md:flex md:w-10/12 md:shadow-lg rounded-md md:pb-10 justify-between w-full">
        <div className="md:px-20  w-full">
          <div className="space-y-4">
            <p className="md:text-3xl text-2xl   text-gray-800 font-serif   font-normal text-center mb-8 md:mb-10">
              Frequently Asked Questions
            </p>
            {faqItems.map((item, index) => (
              <details
                key={index}
                className="group rounded-t-2xl bg-primary-450 hover:bg-primary-400 duration-500 p-6 [&_summary::-webkit-details-marker]:hidden"
              >
                <summary className="flex cursor-pointer items-center justify-between gap-1.5">
                  <h2 className="md:text-lg font-medium text-gray-200">
                    {item.question}
                  </h2>
                  <span className="shrink-0 rounded-full bg-gray-200 p-1.5 text-gray-900 sm:p-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="size-5 shrink-0 transition duration-300 group-open:-rotate-45"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                </summary>
                <p className="mt-4 leading-relaxed text-gray-300">
                  {item.answer}
                </p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
